var AdminControllers = angular.module('AdminControllers', []).run(function($rootScope) {

})

AdminControllers.controller('ShareDocumentsController', function($scope, $http) {
  $scope.allowedCollections = [
    'cohorts',
    'costs',
    'countries',
    'simulations',
    'utilities',
    'treatmentAlgorithms',
    'cohortsT2D',
    'costsT2D',
    'countriesT2D',
    'simulationsT2D',
    'treatmentAlgorithmsT2D',
    'utilitiesT2D'
  ];

  $scope.form = {
    collectionName: $scope.allowedCollections[3], // Default to 'simulationsT2D'
    documentIdsText: '',
    emailsText: ''
  };

  $scope.result = null;

  $scope.accessAllowed = false;
  $scope.loadingUser = true;

  $http.get('/api/authenticated')
  .then(function(response) {
    const email = response.data.user?.email || '';
    $scope.accessAllowed = email.endsWith('@ossianconsulting.com');
    $scope.loadingUser = false;
    $scope.$applyAsync();
  })
  .catch(function(error) {
    $scope.loadingUser = false;
    $scope.accessAllowed = false;
    $scope.$applyAsync();
  });

  $scope.submitShareRequest = function(mode) {

    const documentIds = $scope.form.documentIdsText
    .split('\n')
    .map(s => s.trim())
    .filter(Boolean)
    .map(s => {
      const match = s.match(/([a-f\d]{24})$/i); // extract last 24-char ObjectId
      return match ? match[1] : null;
    })
    .filter(Boolean);


    const emails = $scope.form.emailsText
    .split('\n')
    .map(s => s.trim())
    .filter(Boolean);

    const payload = {
      collectionName: $scope.form.collectionName,
      documentIds,
      emails,
      mode
    };

    $http.post('/api/admin/share/documents', payload)
    .then(response => {
      $scope.result = response.data;
      $scope.sharingInfo = null;
    })
    .catch(error => {
      $scope.result = error.data || { message: 'Request failed' };
    });
  };

  $scope.getSharingInfo = function() {
    const collection = $scope.form.collectionName;
    const ids = $scope.form.documentIdsText
    .split('\n')
    .map(s => s.trim())
    .filter(Boolean)
    .map(s => {
      const match = s.match(/([a-f\d]{24})$/i); // extract last 24-char ObjectId
      return match ? match[1] : null;
    })
    .filter(Boolean);

    if (ids.length !== 1) {
      $scope.sharingInfo = ['❌ Please enter exactly one document ID for fetch.'];
      return;
    }

    const id = ids[0].match(/([a-f\d]{24})$/i)?.[1];

    if (!id) {
      $scope.sharingInfo = ['❌ Invalid document ID format.'];
      return;
    }

    $http.get(`/api/admin/share/documents/${collection}/${id}`)
    .then(function(response) {
      $scope.sharingInfo = response.data.sharedWith;
      $scope.result = null;
    })
    .catch(function(err) {
      $scope.sharingInfo = ['❌ ' + (err.data?.message || 'Request failed')];
    });
  };
});
